import Store from '@/store'

export class ConfigStoreUtils {

    static getConfigs() {
        return Store.getters["config-store/getConfigs"];
    }

    static getFolders() {
        return Store.getters["config-store/getFolders"];
    }

    static getMergeHistory() {
        return Store.getters["config-store/getMergeHistory"];
    }

    static pushConfig(config, data) {
        return Store.dispatch("config-store/pushConfig", {config, data});
    }

    static pushMergeHistory(historyModel, datas) {
        return Store.dispatch("config-store/pushMergeHistory", {historyModel, datas});
    }

    static pushMasterConfig(config, data) {
        return Store.dispatch("config-store/pushMasterConfig", {config, data});
    }

    static updateConfig(config) {
        return Store.dispatch("config-store/updateConfig", config);
    }

    static fetchMergeHistory() {
        return Store.dispatch("config-store/fetchMergeHistory");
    }

    static  updateMetadata(uid){
        return Store.dispatch("config-store/updateMetadata", uid);
    }

    static updateReleaseConfig(config, data) {
        return Store.dispatch("config-store/updateReleaseConfig", {config, data});
    }

    static deleteConfig(uid) {
        return Store.dispatch("config-store/deleteConfig", uid);
    }

    static deleteConfigs(uids) {
        return Store.dispatch("config-store/deleteConfigs", uids);
    }

    static deleteMasterConfig(uid) {
        return Store.dispatch("config-store/deleteMasterConfig", uid);
    }

    static getReleaseConfigs() {
        return Store.getters["config-store/getReleaseConfigs"];
    }

    static getMasterConfigs() {
        return Store.getters["config-store/getMasterConfigs"];
    }

    static pushReleaseConfig(value) {
        return Store.dispatch("config-store/pushReleaseConfig", value, true);
    }

    static removeReleaseConfig(uid) {
        return Store.dispatch("config-store/removeReleaseConfig", uid);
    }

    static getConfigData(path) {
        return Store.dispatch("config-store/getConfigData", path);
    }

    //TMP
    static copyData() {
        return Store.dispatch("config-store/copyData");
    }

    static removeData() {
        return Store.dispatch("config-store/removeData");
    }

    static validate() {
        return Store.dispatch("config-store/validate");
    }

    static fetchReleaseConfigs() {
        return Store.dispatch("config-store/fetchReleaseConfigs");
    }

    static getSharedConfigs() {
        return Store.getters["config-store/getSharedConfigs"];
    }

    static fetchSharedConfigs() {
        return Store.dispatch("config-store/fetchSharedConfigs");
    }

    static pushSharedConfig(config, data) {
        return Store.dispatch("config-store/pushSharedConfig", {config, data});
    }

    static updateSharedConfigMeta(config) {
        return Store.dispatch("config-store/updateSharedConfigMeta", config);
    }

    static deleteSharedConfig(uid) {
        return Store.dispatch("config-store/deleteSharedConfig", uid);
    }

    static findLinkedConfigs(sharedUid) {
        return Store.dispatch("config-store/findLinkedConfigs", sharedUid);
    }

    static unlinkSharedConfigs(linked) {
        return Store.dispatch("config-store/unlinkSharedConfigs", linked);
    }

    static setSharedConfigOnConfig(path, sharedUid) {
        return Store.dispatch("config-store/setSharedConfigOnConfig", {path, sharedUid});
    }

    static getConfigMetadataPath(uid) {
        return Store.dispatch("config-store/getConfigMetadataPath", uid);
    }

    static getSharedConfigUidForConfig(configUid) {
        return Store.dispatch("config-store/getSharedConfigUidForConfig", configUid);
    }

    static saveDeployedSource(data, sharedConfigUid, sharedConfigData, storageName) {
        return Store.dispatch("config-store/saveDeployedSource", {data, sharedConfigUid, sharedConfigData, storageName});
    }

    static getDeployedSourceByName(storageName) {
        return Store.dispatch("config-store/getDeployedSourceByName", storageName);
    }

    static removeDeployedSource(storageName) {
        return Store.dispatch("config-store/removeDeployedSource", storageName);
    }

}